import { connect } from 'react-redux';

import CustomerOrdersSettings from '../components/CustomerOrdersSettings';
import { updateSettings } from '../actions';

import api from '../../../utils/api';

const mapActionCreators = dispatch => ({
    updateConfigurations: payload => dispatch(updateSettings(payload)),
    onSubmit: payload =>
        dispatch(
            api.actions.user.updateSettings({ setting: { default_user: null, customer_order_setting: payload.toJS() } })
        ),
});

const mapStateToProps = state => ({
    initialValues: state.settings.get('customer_order_setting'),
});

export default connect(
    mapStateToProps,
    mapActionCreators
)(CustomerOrdersSettings);
